module.exports = __webpack_public_path__ + "img/banner_doctor_coop_2.5e0fd561.png";